module.exports = __webpack_public_path__ + "img/simplification-vendor.4b64d8fa.png";